import React from "react"
import "./CoveragePage.css"

const CoveragePage = () => {
  return (
    <div className="epw-coverage-page">

      <main>
        <header className="epw-coverage-hero">
          <div className="epw-wrap epw-hero-grid">
            <div>
              <p className="epw-eyebrow">Coverage</p>
              <h1>Global perspective. Regional depth.</h1>
              <p>
                EnergyPulseWorld combines a global view of major energy and economic
                developments with deeper regional intelligence across Asia, the Middle East
                and North Africa, and Sub-Saharan Africa.
              </p>
            </div>

            <div className="epw-globe-wrap" aria-label="EnergyPulseWorld regional coverage">
              <div className="epw-globe">
                <div className="epw-region-dot epw-dot-asia"><span>Asia</span></div>
                <div className="epw-region-dot epw-dot-mena"><span>MENA</span></div>
                <div className="epw-region-dot epw-dot-africa"><span>Sub-Saharan Africa</span></div>
              </div>
            </div>
          </div>
        </header>

        <section className="epw-main">
          <div className="epw-wrap">

            <section>
              <div className="epw-section-head">
                <p className="epw-eyebrow">Current Regional Focus</p>
                <h2>Three regions at the core of EnergyPulseWorld intelligence</h2>
                <p>
                  Each regional view connects energy developments with macroeconomic,
                  industrial, commodity and trade conditions relevant to businesses and decision-makers.
                </p>
              </div>

              <div className="epw-region-grid">
                <article className="epw-region-card">
                  <span className="epw-region-tag">Asia</span>
                  <h3>Asia</h3>
                  <p>
                    Coverage focuses on major Asian economies and ASEAN markets, reflecting the
                    region's central role in global manufacturing, energy demand and international trade.
                  </p>
                  <ul>
                    <li>China, India and Japan</li>
                    <li>ASEAN economies</li>
                    <li>Energy demand and industrial production</li>
                    <li>Commodity and trade exposure</li>
                  </ul>
                </article>

                <article className="epw-region-card">
                  <span className="epw-region-tag">Middle East &amp; North Africa</span>
                  <h3>Middle East &amp; North Africa</h3>
                  <p>
                    Analysis covers both major energy-producing and energy-importing economies,
                    with attention to oil, gas, fertilizers, industry and strategic trade routes.
                  </p>
                  <ul>
                    <li>North Africa</li>
                    <li>Eastern Mediterranean</li>
                    <li>Gulf Cooperation Council</li>
                    <li>Energy supply, industry and trade</li>
                  </ul>
                </article>

                <article className="epw-region-card">
                  <span className="epw-region-tag">Sub-Saharan Africa</span>
                  <h3>Sub-Saharan Africa</h3>
                  <p>
                    Coverage spans selected economies across Eastern, Western and Southern Africa,
                    with emphasis on energy access, imports, industrial costs and market development.
                  </p>
                  <ul>
                    <li>Eastern Africa</li>
                    <li>Western Africa</li>
                    <li>Southern Africa</li>
                    <li>Energy, trade and investment dynamics</li>
                  </ul>
                </article>
              </div>
            </section>

            <section className="epw-global-band">
              <div>
                <p className="epw-eyebrow" style={{ color: "#ffb2bf" }}>Global View</p>
                <h2>One global lens for connected markets.</h2>
              </div>

              <div>
                <p>
                  EnergyPulseWorld also follows major global developments that can transmit
                  across regions through oil and gas prices, shipping, fertilizers, industrial
                  commodities, inflation, supply chains and trade. This global perspective provides
                  the context for understanding why similar market shocks can produce very different
                  outcomes across individual countries and regions.
                </p>
              </div>
            </section>

            <section className="epw-expansion">
              <div className="epw-section-head">
                <p className="epw-eyebrow">Future Expansion</p>
                <h2>Designed to extend as demand and coverage grow</h2>
                <p>
                  The EnergyPulseWorld framework is built to support additional regional depth over time.
                  Potential future coverage includes dedicated insight for Europe and the Americas.
                </p>
              </div>

              <div className="epw-expansion-grid">
                <article className="epw-future-card">
                  <span className="epw-future-label">Potential Expansion</span>
                  <h3>Europe</h3>
                  <p>
                    Deeper coverage could examine energy security, industrial competitiveness,
                    gas and power markets, decarbonization, carbon costs and the implications of
                    the energy transition for trade and manufacturing.
                  </p>
                </article>

                <article className="epw-future-card">
                  <span className="epw-future-label">Potential Expansion</span>
                  <h3>The Americas</h3>
                  <p>
                    Future coverage could include North, Central and South America, with attention
                    to oil and gas production, LNG, power markets, industrial reshoring, commodity
                    exports, trade flows and regional supply-chain dynamics.
                  </p>
                </article>
              </div>
            </section>

            <section className="epw-closing">
              <strong>Global intelligence with regional relevance.</strong>
              <p>
                EnergyPulseWorld is structured to grow from its current three-region focus into a broader
                global intelligence platform while preserving the regional depth needed for practical
                business and market analysis.
              </p>
            </section>

          </div>
        </section>
      </main>
    </div>
  )
}

export default CoveragePage
